import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  access_token: null,
  user: null,
  accesses: null,
  attendance_status: true,
}

export const AuthSlices = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: (state: any, action: any) => {
      state.user = action.payload.user
      state.attendance_status = action.payload.attendance_status
    },

    manageUserData: (state: any, action: any) => {
      state.access_token = action.payload.user.access_token
      state.user = action.payload.user
    },

    userAccess: (state: any, action: any) => {
      state.accesses = action.payload.accesses
    },

    registration: (state: any, action: any) => {},

    logout: (state: any) => {
      state.access_token = null
      state.user = null
      state.accesses = null
    },

    updateUser: (state, action) => {
      state.user = action.payload.user
    },
    updateAvatarUser: (state, action) => {
      // @ts-ignore
      state.user.avatar = ''
    },
  },
})
